
import { useQuery} from '@apollo/client';

import { GET_ME } from '../queries/getMe';

export const useIsTeacher = () => {
  const { loading: meLoading , error: meError , data: me } = useQuery(GET_ME);

  return !meLoading && !meError && me.me.organisation.membership.isTeacherPersona;
};
